import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=21747603&scoped=true"
import script from "./Agenda.vue?vue&type=script&lang=ts"
export * from "./Agenda.vue?vue&type=script&lang=ts"
import style0 from "./Agenda.vue?vue&type=style&index=0&id=21747603&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21747603",
  null
  
)

export default component.exports